import TermsAndConditions from "pages/public/TermsAndConditions"

const AcceptTermsAndConditions = () => {
  return <TermsAndConditions actionable />
}

export default AcceptTermsAndConditions
